module.exports = __webpack_public_path__ + "static/media/face-book.391f03a5.svg";